import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CelticOrnament from "@/components/CelticOrnament";

// Wrapper for policy/legal pages — keeps consistent layout
export default function LegalPage({ title, eyebrow = "POLICY", lastUpdated, children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <section className="relative max-w-3xl mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-12">
          <div className="flex flex-col items-center text-center mb-12">
            <div className="eyebrow mb-5">{eyebrow}</div>
            <h1
              className="font-cinzel text-cream text-4xl md:text-5xl leading-tight tracking-wide"
              data-testid="legal-page-title"
            >
              {title}
            </h1>
            <CelticOrnament size={70} className="mt-6 opacity-70" />
            {lastUpdated && (
              <div className="mt-5 text-cream-muted text-xs font-cinzel tracking-[0.28em]">
                LAST UPDATED · {lastUpdated.toUpperCase()}
              </div>
            )}
          </div>
        </section>

        <section className="max-w-3xl mx-auto px-6 md:px-10 pb-24">
          <div className="prose-cream" data-testid="legal-page-content">
            {children}
          </div>

          <div className="gold-divider mt-16 mb-10" />

          <div className="text-center">
            <Link to="/" className="btn-ghost" data-testid="legal-back-home">
              Return to Sanctuary
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
